export const SET_UPDATED_ROLES = 'set_updated_roles';
export const SET_USER_TYPE = 'set_user_type';
export const CHANGE_DATASET_AUTH = 'add_dataset_auth';
export const SET_USER = 'set_user';
export const RESET_USER = 'reset_user';
export const SET_USER_NAME = 'set_user_name';
export const SET_USER_EMAIL = 'set_user_email';
export const SET_UPDATED_STATUS_NOTIFICATIONS =
  'set_updated_status_notifications';
